import * as React from 'react';

import { BookingWidgetThemeContext } from 'contexts/BookingWidgetThemeContext';
import { PMPProductCardViewProps } from 'lib/themes/themes';
import { getCustomComponent } from 'components/Themes';

export const PMPProductCardView = (props: PMPProductCardViewProps) => {
  const bookingWidgetTheme = React.useContext(BookingWidgetThemeContext);

  const CustomComponent = getCustomComponent(bookingWidgetTheme, 'PMPProductCardView');
  return <CustomComponent {...props} />;
};
